import React from 'react';
import ILPApplication from './ILP/ILPApplication';

// KycDemo now renders the complete Arunachal eILP Application flow
// This provides a full end-to-end permit application experience
// with integrated Aadhaar verification (simulated for demo)

function KycDemo() {
  return <ILPApplication />;
}

export default KycDemo;
